<template>
  <runtime-template dir="auto" />
</template>

<script>
import RuntimeTemplate from "vue3-runtime-template"

export default {
  components: {
    RuntimeTemplate
  }
}
</script>

<style lang="scss" scoped>
[dir="auto"] {
  text-align: start;
}
</style>
